import { theme } from '@qr-front/ui'
import { getVersionForClone } from '@qr-front/ui/utils'
import { atom } from 'jotai'

import {
	primaryColorAtom,
	secondaryColorAtom,
} from '@/content-from-sections/client'

import { isDemoModeAtom } from '../../../generatorState'

export const WIFI_DEMO_PRIMARY_COLOR = getVersionForClone({
	base: theme.colors['green-70'],
	clone1: '#FF766A',
})

export const wifiPrimaryColorAtom = atom((get) =>
	get(isDemoModeAtom) ? WIFI_DEMO_PRIMARY_COLOR : get(primaryColorAtom),
)

export const wifiSecondaryColorAtom = atom((get) =>
	get(isDemoModeAtom) ? theme.colors.black : get(secondaryColorAtom),
)
